export default __webpack_public_path__ + "static/media/occamx-bg@1x.2d4efde3.webp";